import { api } from '@/api'
import type { ApiResponse } from '@/api/typings/response.typing'

interface ResetPasswordPayload extends Record<string, string> {
  email: string
  password: string
  token: string
}

export function emailResetPasswordUpdateAction(payload: ResetPasswordPayload): Promise<ApiResponse<null>> {
  return api.post<ApiResponse<null>>('/auth/reset-password', { ...payload })
}
